import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import { AlertSeverityEnum, MaterialTransferido } from "../interfaces";
import {  IconButton, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import CustomCantidadInput from "../components/ui/CustomCantidadInput";
import ButtonSeries from "../components/ui/ButtonSeries/ButtonSeries";

export const useTableColumnsTrasladoSerie = () => {

  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarProducto = useCargarSeriesProductos(s => s.handleEliminarProducto)
  const setOpenModalSeries = useCargarSeriesProductos(s => s.setOpenModalSeries)
  const setAuxRow = useCargarSeriesProductos(s => s.setAuxRow)
  const setAlert = useUiStore(s => s.setAlert);
  //* state
  const [deleteProductoId, setDeleteProductoId] = useState<string[]>([]);

  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [

    {
      accessorKey: "codigo",
      header: "Código",
    },

    {
      accessorKey: "producto_data.stock_actual",
      header: "Stock actual",
      size: 150,
      Cell: ({ row }) => {
        const stock = row.original.producto_data?.stock_actual
        if (row.original.producto_data?.stock_actual == 0 || Number(row.original.cantidad) > Number(row.original.producto_data?.stock_actual)) {
          return (
            <Typography color={'error'}>{stock}</Typography>
          )
        } else {

          return row.original.producto_data?.stock_actual
        }
      }
    },
    {
      accessorKey: "producto_data.descripcion",
      header: "Descripcion",
      size: 150,
      Cell: ({ row }) => {
        if (row.original.producto_data?.stock_actual === 0) {
          return (
            <Typography color={'error'} sx={{ fontSize: '0.8rem' }}>No existe en la ubicación buscada</Typography>
          )
        } else {
          return row.original.producto_data?.descripcion || 'N/A'
        }
      }
    },
    {
      accessorKey: "producto_data.categoria_producto",
      header: "categoria_producto",
      size: 200,
      Cell: ({ row }) => row.original.producto_data?.categoria_producto || 'N/A'
    },
    /* {
      accessorKey: "producto_data.subcategoria_producto",
      header: "subcategoria_producto",
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto || 'N/A'
    }, */
  ], [])

  const columnsIngresoInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [

    {
      accessorKey: 'accion',
      header: 'Accion ',
      size: 100,
      Cell: ({ row }) => (
        <IconButton
          //onClick={() => handleEliminarProducto(row.original.id)}
          onClick={() => {
            handleEliminarProducto(row.original.id),
              setDeleteProductoId(prevIds => [...prevIds, row.original.codigo])
          }}
        >
          <Delete />
        </IconButton>
      )
    },
    {
      accessorKey: "cantidad",
      header: "Cant. Requerida",
      size: 150,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      ),
    },
    /* {
      accessorKey: 'contiene_series',
      header: 'Contiene',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return <Checkbox
          value={row.original.contiene_serie ?? false}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={row.original.contiene_serie ?? false}
          onChange={e => {

            handleActualizarProducto(row.original.id, {
              ...row.original,
              contiene_serie: e.target.checked,
            })
          }
          }
        />
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie
        } = original

        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              if (!row.original.contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);

              setOpenModalSeries(true);
              setAuxRow(row.original)
            }}
          />
        )
      }
    },
    ...columnsInfoProducto
  ], [])

  const columnsSolicitudTransferenciaInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => (
        <IconButton
          onClick={() => handleEliminarProducto(row.original.id)}
        >
          <Delete />
        </IconButton>
      )
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 125,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      ),
    },
    ...columnsInfoProducto
  ], [])


  const columnsRevisarSolicitudTransferencia = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: "cantidad",
      header: "cantidad",
    },
    {
      accessorKey: "codigo",
      header: "Código",
    },
    {
      accessorKey: "producto_data.stock_actual",
      header: "Stock actual",
    },
    {
      accessorKey: "producto_data.descripcion",
      header: "Descripcion",
    },
    {
      accessorKey: "producto_data.categoria_producto",
      header: "categoria_producto",
    },
    /*   {
        accessorKey: "producto_data.subcategoria_producto",
        header: "subcategoria_producto",
      }, */
  ], [])

  const columnsTrasladoInventarioPorSolc = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    /*  {
       accessorKey: 'contiene_series',
       header: 'Contiene',
       size: 100,
       enableColumnFilter: false,
       enableSorting: false,
       Cell: ({ row }) => {
         return <Checkbox
           value={row.original.contiene_serie ?? false}
           inputProps={{ 'aria-label': 'controlled' }}
           checked={row.original.contiene_serie ?? false}
           onChange={e => {
 
             handleActualizarProducto(row.original.id, {
               ...row.original,
               contiene_serie: e.target.checked,
             })
           }
           }
         />
       }
     }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie
        } = original

        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              if (!row.original.contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);

              setOpenModalSeries(true);
              setAuxRow(row.original)
            }}
          />
        )
      }
    },
    {
      accessorKey: "cantidad",
      header: "cantidad",
    },
    ...columnsInfoProducto
  ], [])

  return {
    columnsIngresoInventario,
    columnsSolicitudTransferenciaInventario,
    columnsRevisarSolicitudTransferencia,
    columnsTrasladoInventarioPorSolc,
    deleteProductoId
  }


}